import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import TapIcon from '../../../services/TapIcon';
import { HRM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import DateService from '../../../services/DateService';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import download from '../../../services/DownloadFile';
import WorkLogSearchModal from './WorkLogSearchModal';
import swal from 'sweetalert';
import WorklogDetail from './WorklogDetail';
import TapHelper from '../../../services/TapHelper';
import WorklogDetailModal from './WorklogDetailModal';

const WorklogList = forwardRef((props, ref) => {
     const isCompactMode = props?.show || props?.projectWorklog;
    const searchworklogModalRef         =   useRef(null);
    const detailModalRef                =   useRef(null);
    const criteriaRef                   =   useRef();
    const access_token                  =   useSelector(state => state.auth.access_token);
    let listUrl = HRM_API_BASE_URL_2 + "/work_log/list";

    let initListData = {
        minimizeTable   :   false,
        items           :   [],
        meta            :   null,
        loading         :   false,
        page            :   1,
        per_page        :   50
    };
    
    const [downloadLoading, setDownloadLoading]             =   useState(false);
    const [formSearchedElems, setFormSearchedElems]         =   useState([]);
    const [submittedSearchForm, setSubmittedSearchForm]     =   useState({});
    const [itemData, setItemData]                           =   useState({ ...initListData });
    const [criteriaHeight, setCriteriaHeight]               =   useState(0);
    const [selectedWorklogId, setSelectedWorklogId]         =   useState(null);
    const [selectedWorklog, setSelectedWorklog]             =   useState(null);



    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height);
            }
        }
    };

    useEffect(() => {
        updateCriteriaHeight();
        loadListData(1);
    }, [submittedSearchForm]);
  

    const viewModalInit = (worklogId) => {
        if (detailModalRef.current) {
            detailModalRef.current.initViewModalHandler(worklogId);
        }
    }
    const loadListData = async (page = 1, searchParams = null) => {
        setItemData(pd => ({ ...pd, loading: true, page: page }));
        try {
            const headers = { 'Authorization': 'Bearer ' + access_token };
            let params = {
                page: page,
                ...(searchParams !== null ? searchParams : submittedSearchForm),
                ...(props?.ticket_id ? { search_ticket_id: props.ticket_id } : {}),
                ...(props?.project_id ? { search_project_id: props.project_id, need_ticket: "Y" } : {})

            };
            const response = await api.server2Api.get(listUrl, {
                params, headers
            });
            let respData = response.data;
            let meta = {
                from            :   respData.from,
                to              :   respData.to,
                total           :   respData.total,
                last_page       :   respData.last_page,
                per_page        :   respData.per_page,
                current_page    :   respData.current_page
            };
            setItemData(pd => ({
                ...pd,
                items: respData.data || [],
                meta: meta
            }));
        } catch (error) {
            toast.error('Failed to load Worklog Listing');
        } finally {
            setItemData(pd => ({ ...pd, loading: false }));
        }
    };

    const searchHandle = (element, data) => {
        setFormSearchedElems(element);
        setSubmittedSearchForm(data);
    };

    const employeeSearchClear = () => {
        setSubmittedSearchForm({});
        setFormSearchedElems([]);
        if (searchworklogModalRef.current && searchworklogModalRef.current.resetModalFilters) {
            searchworklogModalRef.current.resetModalFilters();
        }
    };

    const searchModalHandle = () => {
        if (searchworklogModalRef.current) {
            searchworklogModalRef.current.initModalHandler();
        }
    };
    const worklogDownloadHandler = () => {
        let params = { action: "download", ...submittedSearchForm }

        const hasDateFilter = submittedSearchForm.date_range ||
            submittedSearchForm.start_date ||
            submittedSearchForm.end_date;

        if (!hasDateFilter) {
            swal({
                title: "Download",
                text: "The download will be for Current Month's Transaction, in case you want different Transaction Period then please change by filter.",
                icon: "warning",
                buttons: ["Cancel", "Okay"],
            }).then(willDownload => {
                if (willDownload) {
                    params = { ...params, date_range: "current_month" }
                    downloadHandler(params)
                }
            });
        } else {
            downloadHandler(params);
        }
    }

    const downloadHandler = (params) => {
        setDownloadLoading(true);
        HttpAPICall.withAthorization('GET', listUrl, access_token, params, {}, (response) => {
            download.file(response.data.file_path);
        }).finally(() => setDownloadLoading(false));
    };

    const viewWorklogDetail = (worklog) => {
        setItemData(pd => ({ ...pd, minimizeTable: true }));
        setSelectedWorklogId(worklog.id);
        setSelectedWorklog(worklog?.work_log_type?.name)
    };

    const closeWorklogDetail = () => {
        setSelectedWorklogId(null);
        setItemData(pd => ({ ...pd, minimizeTable: false }));
    };

    const headerJsx = () => {
        return (
            <>
                <Helmet>
                    <title>{itemData.minimizeTable ? 'Worklog Detail' : 'Worklog List'}</title>
                </Helmet>
                <div className="page_title m0 row">
                    <div className='col-sm-12'>
                        <div className='row'>
                            {!itemData.minimizeTable ? (
                                <>
                                    <div className='col-sm-6'>
                                        <h3 className='mb-0'>Worklog List</h3>
                                    </div>
                                    <div className='col-sm-6'>
                                        <div className='text-end d-flex gap-2 align-items-center justify-content-end mt15'>
                                            <button type="button" className="btn btn-secondary" disabled={itemData.loading} onClick={searchModalHandle}>
                                                <TapIcon.imageIcon icon={TapIcon.SearchIcon} />
                                            </button>
                                            <button type="button" className="btn btn-secondary"
                                                disabled={downloadLoading || itemData.loading}
                                                onClick={worklogDownloadHandler}>
                                                <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                                                {downloadLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='col-sm-3'>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <h3>Worklog</h3>
                                                <div className='text-start d-flex align-items-center justify-content-end mt15 gap-1'>
                                                    <button type="button" className="btn btn-secondary" disabled={itemData.loading} onClick={searchModalHandle}>
                                                        <TapIcon.imageIcon icon={TapIcon.SearchIcon} />
                                                    </button>
                                                    <button type="button" className="btn btn-secondary"
                                                        disabled={downloadLoading || itemData.loading}
                                                        onClick={worklogDownloadHandler}>
                                                        <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                                                    </button>
                                                </div>
                                            </div>
                                       
                                    </div>
                                    <div className='col-sm-9'>
                                        <h3 className='mb-0'>WorkLog Detail : {selectedWorklog}</h3>
                                        <div className='text-end d-flex align-items-center justify-content-end mt15'>
                                            <button type="button" className="btn btn-secondary" onClick={closeWorklogDetail}>
                                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} />
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const worklogListJsx = () => {
        return (
            <>
                {!isCompactMode && (
                    <div
                        ref={criteriaRef}
                        style={{
                            position: 'sticky',
                            top: 0,
                            background: 'white',
                        }}
                    >
                        <DisplaySearchCriteria
                            searchedElems={formSearchedElems}
                            onClearFilter={employeeSearchClear}
                        />
                    </div>
                )}
                    <table className="table table-bordered align-middle bg-white">
                        <thead className="align-middle table-secondary" style={{
                            top: `${criteriaHeight}px`,
                            position: 'sticky',
                        }}>
                            {itemData.minimizeTable ? (
                                <tr className='text-center'>
                                <th scope="col">Worklog</th>
                            </tr>
                        ) : (
                            <tr className='text-center'>
                                <th style={{ width: "5%" }}>S.No</th>
                                {props?.projectWorklog && <th style={{ width: "12%" }}>Ticket ID</th>}
                                {props?.projectWorklog && <th style={{ width: "12%" }}>Ticket Header</th>}
                                <th style={{ width: "15%" }}>Employee</th>
                                <th style={{ width: "15%" }}>Work Log Type</th>
                                {isCompactMode ? "" :
                                    <th style={{ width: "12%" }}>SIte</th>}
                                <th style={{ width: "15%" }}>Start Time</th>
                                <th style={{ width: "15%" }}>End Time</th>
                                <th style={{ width: "10%" }}>Duration</th>
                                {isCompactMode ? "" :
                                    <th style={{ width: "10%" }}>Notes</th>}
                                {isCompactMode && <th style={{ width: "10%" }}>Action</th>}
                            </tr>
                        )}
                    </thead>
                        <tbody>
                            {itemData.loading ? (
                                <tr>
                                    <td className='text-center' colSpan={itemData.minimizeTable ? 1 : 8}>
                                        <Loader />
                                    </td>
                                </tr>
                            ) : (
                                itemData.items && itemData.items.length > 0 ? (
                                    itemData.items.map((item, index) => {
                                        console.log("Rendering row", item);
                                        const formatSeconds = (seconds) => {
                                            const hrs = Math.floor(seconds / 3600);
                                            const mins = Math.floor((seconds % 3600) / 60);
                                            return `${hrs}h ${mins}m`;
                                        };

                                        if (itemData.minimizeTable) {
                                            return (
                                                <tr key={item.id} className={selectedWorklogId === item.id ? 'bg-light' : ''}>
                                                    <td className='text-start'>
                                                        
                                                        <a href="#"  onClick={() => viewWorklogDetail(item)}>
                                                            {item.work_log_type?.name || '-'}
                                                        </a>
                                                        <div className="mt-1">
                                                            <span className="text-xs ">{DateService.dateTimeFormat(item.start_time)}</span>
                                                            <span className="float-end text-xs">{formatSeconds(item.log_seconds)}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        } else {
                                            return (
                                                <tr key={item.id}>
                                                    <td className='text-center'>{(itemData.meta?.from || 1) + index}</td>
                                                    {props?.projectWorklog && <td className='text-center'> {item?.ticket?.activity_id || '-'} </td>}
                                                    {props?.projectWorklog && <td className='text-center'> {item?.ticket?.header || '-'} </td>}
                                                    <td className='text-center'>
                                                        {isCompactMode ? <>{item?.employee?.name || '-'}</> : <a href="#" onClick={() => viewWorklogDetail(item)}> {item?.employee?.name || '-'} </a>}
                                                    </td>
                                                    <td className='text-center'> {item.work_log_type?.name || '-'}</td>
                                                    {isCompactMode ? "" : <td className='text-center'>{item?.employee?.site_name || "-"}</td>}

                                                    <td className='text-center'>{item.start_time ? DateService.dateTimeFormat(item.start_time) : '-'}</td>
                                                    <td className='text-center'>{item.end_time ? DateService.dateTimeFormat(item.end_time) : '-'}</td>
                                                    <td className='text-center'>{formatSeconds(item.log_seconds)}</td>
                                                    {isCompactMode ? "" :
                                                        <td>{item.notes ? TapHelper.textTruncate(item.notes, 15) : ''}</td>}
                                                    {isCompactMode &&
                                                        <td className="text-center"> <TapIcon.imageIcon icon={TapIcon.ListActionIcon} alt="action-icon" className="img-fluid pr10 pl10" data-bs-toggle="dropdown" href="#"
                                                            role="button" aria-expanded="false" />
                                                            <ul className="dropdown-menu" style={{ cursor: "pointer" }} >
                                                             <li className="dropdown-item" onClick={() => viewModalInit(item.id)} >view</li>
                                                            </ul>
                                                        </td>}
                                                </tr>
                                            );
                                        }
                                    })
                                ) : (
                                    <tr>
                                        <td className='text-center' colSpan={itemData.minimizeTable ? 1 : 8 || props?.projectWorklog ? 9 :9}>
                                            No Record
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                 <DisplayListPagination meta={itemData.meta} onPageChange={(e) => loadListData(e.selected + 1)} />
                
            </>
        );
    };

    return (
        <>
            {isCompactMode ? <>
                <div className="page_containt row">
                    <div className='col-sm-12 pageTbl mt-2' style={{ maxHeight: "500px" }}>
                        {worklogListJsx()}
                    </div>
                </div>
                <WorklogDetailModal ref={detailModalRef} worklogId={selectedWorklogId} />
            </> : <ApplicationLayout>
                <WorkLogSearchModal
                    ref={searchworklogModalRef}
                    searchHandle={(element, searchData) => searchHandle(element, searchData)}
                    listingLoading={itemData.loading}
                    formSearchedElems={formSearchedElems}
                    appliedSearchData={submittedSearchForm}
                />
                {headerJsx()}
                <div className="container-fluid pl5">
                    <div className='page_containt row'>
                        <div className={itemData.minimizeTable ? 'col-sm-4 col-md-3 pageTbl' : 'col-sm-12 pageTbl'}>
                            {worklogListJsx()}
                        </div>
                        {itemData.minimizeTable && selectedWorklogId && (
                            <div className="tap_border_left col-sm-8 col-md-9 p-3  bg-white" >
                                <WorklogDetail
                                    worklogId={selectedWorklogId}
                                    onClose={closeWorklogDetail}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </ApplicationLayout>}

        </>

    );
});

export default WorklogList;